/**
 * useSmartCoach - Smart Coach / Ask Why / Fix This modal state
 * Extracted from App.js Phase 5 refactoring
 */
import { useState, useCallback } from 'react';

const useSmartCoach = () => {
  const [showAskWhyModal, setShowAskWhyModal] = useState(false);
  const [askWhyPrefill, setAskWhyPrefill] = useState('');
  const [askWhyInsightType, setAskWhyInsightType] = useState('');
  const [askWhyUsedToday, setAskWhyUsedToday] = useState(0);
  const [showFixThisModal, setShowFixThisModal] = useState(false);
  const [fixThisInsightType, setFixThisInsightType] = useState('');
  const [fixThisHeadline, setFixThisHeadline] = useState('');

  const handleHealthIntelFixThis = useCallback((insightType, headline) => {
    setFixThisInsightType(insightType || '');
    setFixThisHeadline(headline || '');
    setShowFixThisModal(true);
  }, []);

  const handleHealthIntelAskWhy = useCallback((prefill, insightType) => {
    setAskWhyPrefill(prefill || '');
    setAskWhyInsightType(insightType || '');
    setShowAskWhyModal(true);
  }, []);

  const openSmartCoach = useCallback(() => {
    setAskWhyPrefill('');
    setAskWhyInsightType('smart_coach');
    setShowAskWhyModal(true);
  }, []);

  return {
    showAskWhyModal, setShowAskWhyModal,
    askWhyPrefill, setAskWhyPrefill,
    askWhyInsightType, setAskWhyInsightType,
    askWhyUsedToday, setAskWhyUsedToday,
    showFixThisModal, setShowFixThisModal,
    fixThisInsightType, setFixThisInsightType,
    fixThisHeadline, setFixThisHeadline,
    handleHealthIntelFixThis,
    handleHealthIntelAskWhy,
    openSmartCoach
  };
};

export default useSmartCoach;
